<p>
    {{ "AccessPendingChanges.Content1" | translate }} <strong>{{ "General.Discard" | translate }}</strong>
    {{ "AccessPendingChanges.Content2" | translate }} <strong>{{ "General.Cancel" | translate }}</strong>
    {{ "AccessPendingChanges.Content3" | translate }}
</p>
